<template>
  <div class="col-12 mx-0 px-1">

      <!-- A container for a list of selectable options -->
      <div class="p-2 my-2 cursor-pointer"
          v-for="(option, i) in options.filter( el => el.hasPermission)"
          :key="i"
          @click="selectOption(option.id)"
          :class="[
            option.selected && 'bg-primary text-white shadow',
            mouseOverOption === i && 'border border-dark'
            ]"
          style="border-radius:20px"
          @mouseover="handleMouseOver(i)"
          @mouseout="handleMouseOver(i, true)"
        >
        <!-- Display the label of each option -->
        <span class="ml-3">{{ option.label }}</span>
      </div>
  </div>
</template>

<script>
export default {
  name: 'ListOptions',

  data() {
    return {
      mouseOverOption: null,
    };
  },
  props: {
    options:{ // An array of selectable options passed as a prop
      type: Array,
      required: true,
      default: [],
    },
    defaultOption: {  // A default option number passed as a prop
      type: Number,
      required: false,
      default: 1
    }
  },

  mounted() {
    // Emit an event with the default option when the component is mounted
    this.$emit('optionSelected', this.defaultOption);
  },

  methods: {
    handleMouseOver(i, out = null){
      if( out ) {
        this.mouseOverOption = null
      } else {
        this.mouseOverOption = i
      }
    },

    // Method to select an option and emit an event with the selected option
    selectOption(option){
      this.$emit('optionSelected', option);
    }
  },
};
</script>
